// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RiGJ","top":"styles_top__1ylxE","left":"styles_left__2nhZR","description":"styles_description__xppOl"};